(function($){
  $(function(){ 
    if (typeof WOW === 'function') {
      try { new WOW().init(); } catch (e) { }
    }

    if (typeof checkScreenSize === 'function') {
      checkScreenSize();
      $(window).on('resize', function () {
        checkScreenSize();
      });
    } else {
      $(window).on('resize', function () {});
    }
    var $banner = $('#banner_slider');
    if ($banner.length && typeof $banner.owlCarousel === 'function') {
      $banner.owlCarousel({
        margin: 30,
        loop: true,
        smartSpeed: 400,  
        autoplay: true,
        autoplayHoverPause: true,
        nav: false,
        dots: true,
        navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
        responsive: {
          0:   { items: 1 },
          480: { items: 1 },
          700: { items: 1 },
          1000:{ items: 1 },
          1100:{ items: 1 }
        }
      });
    } else {
      if (!$banner.length) {
        console.warn('#banner_slider not found in DOM.');
      } else {
        console.warn('Owl Carousel plugin not available (owlCarousel is not a function).');
      }
    }
  });
})(jQuery);
